import { render, staticRenderFns } from "./DNS.vue?vue&type=template&id=20b2f13e"
import script from "./DNS.vue?vue&type=script&lang=js"
export * from "./DNS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports